<template>
  <article class="card">

    <link-to class="card__image" :to="linkUrl">
      <div class="cover" :style="'background-image: url('+ (this.isImages ?  this.isImages : image) +');'"></div>
    </link-to>

    <section class="card__content">

      <h3 v-html="title"></h3>
      <div class="date font-bold">{{dateStr}}</div>
<!--      <slot></slot>-->
      <div class="description" v-html="text"></div>
      <div class="card__actions">
        <LinkTo class="btn solid--green style-1" :to="linkUrl">Подробнее</LinkTo>
      </div>

    </section>
  </article>
</template>

<script>
  import NewsItemMixin from '../mixins/NewItemMixin.js'

  export default {
    mixins: [NewsItemMixin],
    data() {
      return {
        sizeImgError: '540x540',
        isImages: false,
      };
    },
    computed: {
      linkUrl() {
        return this.link;
      },
    },
    components: {
    },
  }
</script>

<style lang="scss" scoped>

  .card {
    padding: 0;
    margin-bottom: 30px;
    h3 {
      display: inline-block;
      padding-bottom: 15px;
    }
    .date {
       padding-bottom: 5px;
       font-size: 18px;
    }
    @media (max-width: 600px) {
      margin-bottom: 15px;
    }
    .description {
       overflow: hidden;
       text-overflow: ellipsis;
       height: 95px;
    }
    &__image {
      display: block;
      @include ease(opacity);
      &:hover {
        opacity: 0.9;
      }
      .cover {
        @include size(100%, 240px);
        @include background-cover();
        @media (max-width: 600px) {
          height: 300px;
        }
      }
    }

    &__content {
      padding: 20px 0px;
     // border: 2px solid $color-black;
      border-top: none;
      @include font-size(18px, 22px);
      @media (max-width: 600px) {
        padding: 15px;
      }
    }
    &__actions {
      padding: 35px 0 0;

    }
  }
</style>



// WEBPACK FOOTER //
// components/shared/cards/CardCaseSmall.vue